import React, { useEffect } from 'react';
import { X, Loader2, AlertTriangle } from 'lucide-react';
import Button from '../ui/Button';
import { cn } from '../../lib/utils';

export function Sheet({ title, subtitle, onClose, children, testid }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center md:items-center md:p-6" data-testid={testid}>
      <div className="absolute inset-0 bg-ink/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative max-h-[90vh] w-full max-w-[480px] animate-sheet-up overflow-y-auto rounded-t-2xl bg-white p-5 pb-8 shadow-lift md:max-w-lg md:rounded-2xl md:animate-fade-up">
        <div className="mx-auto mb-4 h-1.5 w-10 rounded-full bg-slate-200 md:hidden" />
        <button
          onClick={onClose}
          className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-ink-soft hover:bg-slate-200"
          data-testid="sheet-close"
          aria-label="Fechar"
        >
          <X size={18} />
        </button>
        <h3 className="pr-10 font-heading text-xl font-extrabold text-ink">{title}</h3>
        {subtitle && <p className="mt-0.5 text-sm text-ink-soft">{subtitle}</p>}
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );

}

export function Select({ label, value, onChange, options, testid }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.14em] text-ink-soft">
        {label}
      </span>
      <select
        value={value}
        onChange={onChange}
        data-testid={testid}
        className="h-12 w-full rounded-xl border border-slate-200 bg-white px-4 text-base text-ink focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export function ConfirmDialog({ title, message, confirmLabel = 'Excluir', onCancel, onConfirm, loading }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-6" data-testid="confirm-dialog">
      <div className="absolute inset-0 bg-ink/50 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative w-full max-w-sm rounded-2xl bg-white p-6 shadow-lift">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-rose-100 text-rose-600">
          <AlertTriangle size={20} />
        </span>
        <h3 className="mt-3 font-heading text-lg font-extrabold text-ink">{title}</h3>
        <p className="mt-1 text-sm text-ink-soft">{message}</p>
        <div className="mt-5 flex gap-2.5">
          <Button variant="outline" className="flex-1" onClick={onCancel} data-testid="confirm-cancel">
            Cancelar
          </Button>
          <Button
            className={cn('flex-1 bg-rose-500 hover:bg-rose-600')}
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-ok"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
